import { convertToQuestion } from './parseQuestions'

function parseOptionalQuestions(responseOptionalQuestions): OptionalQuestion[] {
  const questions = Object.keys(responseOptionalQuestions)

  return questions.map((questionId, index) => {
    const question = responseOptionalQuestions[questionId]
    return {
      ...convertToQuestion(questionId, question, index),
      openOptions: question.openOptions
    }
  })
}

export default parseOptionalQuestions
